import { isUndefined } from '@atlassiansox/bxp-shared-utils';
export function createHeaders(headers) {
    return Object.keys(headers).reduce((result, name) => {
        const value = headers[name];
        if (!isUndefined(value)) {
            return Object.assign(Object.assign({}, result), { [name]: value.toString() });
        }
        else {
            return result;
        }
    }, {});
}
//# sourceMappingURL=headers.js.map